import '@fontsource-variable/instrument-sans/index.css';
import '@fontsource-variable/jetbrains-mono/index.css';
import '@dovefiniscono/design/tokens.css';
import './styles/base.css';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { startPwa } from './lib/pwa';
import { SessionProvider, useSession } from './lib/session';
import { applyTheme, readTheme } from './lib/theme';
import { router } from './router';

applyTheme(readTheme());
startPwa();

function App() {
  const session = useSession();

  // Route guards read the session: re-run them whenever it changes.
  useEffect(() => {
    if (session.status === 'loading') return;
    router.update({ ...router.options, context: { session } });
    void router.invalidate();
  }, [session]);

  if (session.status === 'loading') return null;
  return <RouterProvider router={router} context={{ session }} />;
}

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root');

createRoot(root).render(
  <StrictMode>
    <SessionProvider>
      <App />
    </SessionProvider>
  </StrictMode>,
);
